export default __webpack_public_path__ + "static/media/goal-social.bcf6ffec.svg";